import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/finalrefurbish',
  component: () => import('@views/FinalRefurbish/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'finalrefurbish.index',
      component: () => import('@/components/FinalRefurbish/FinalRefurbish')
    },
  ]
}
